import script from "./VerificationAuthenticationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationAuthenticationDialog.vue?vue&type=script&setup=true&lang=js"

import "./VerificationAuthenticationDialog.vue?vue&type=style&index=0&id=10a60dc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a60dc6"]])

export default __exports__